<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      users: [],
      Users: {},
      roles: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchUsers: null,
      SearchMode: false,
      emps: [],
      new_roles: [],
      newRoles: [{}],
      addRoles: [{}],
      editRoles: [{}],
      branches: [],
      user_info: {},
      new_pass: "",
      users_switch: "",
      user_status: 0,
      data: { pass: "" },
      selectedUser: { user_roles: [] },
      cashAccounts: [],
      add_modal: {},
      edit_modal: {},
      edit_pass_modal: {},
      formTried: false,
      editFormTried: false,
      customers_status_logs: [],
    };
  },

  methods: {
    getCustomerStatusLogs() {
      this.http.get("customers/status-logs").then((res) => {
        if (res.status) this.customers_status_logs = res.data;
      });
    },
  },
  computed: {},
  created() {
    this.getCustomerStatusLogs();
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('customers.status_logs')"
    />
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <div class="search-box chat-search-box" style="width: 250px">
              <div class="position-relative mb-4">
                <input
                  @keyup="search()"
                  type="text"
                  class="form-control fa-lg text-light"
                  :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
                  :placeholder="$t('users.searchplaceholder')"
                  v-model="searchUsers"
                  style="background-color: #2a3042 !important"
                />
                <i class="bx bx-search-alt search-icon text-light"></i>
                <button
                  @click="cancelSearchMode()"
                  v-if="SearchMode"
                  class="btn-close text-light"
                  style="position: absolute; top: 12px; left: 250px"
                ></button>
              </div>
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <table
            :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            class="table table-centered table-nowrap table-striped table-hover align-middle"
          >
            <thead>
              <tr
                class="text-light"
                style="background-color: #2a3042 !important"
              >
                <th scope="col">#</th>
                <th scope="col">{{ $t("customers.text") }}</th>
                <th scope="col">{{ $t("customers.old_status") }}</th>
                <th scope="col">{{ $t("customers.new_status") }}</th>
                <th scope="col">{{ $t("customers.changed_by") }}</th>
                <th scope="col">{{ $t("customers.created") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class=""
                v-for="(user, index) in customers_status_logs"
                :key="user.id"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ user.customer.name }}</td>
                <td>
                  {{
                    !user.status
                      ? $t("customers.enabled")
                      : $t("customers.disabled")
                  }}
                </td>
                <td>
                  {{
                    user.status
                      ? $t("customers.enabled")
                      : $t("customers.disabled")
                  }}
                </td>
                <td>
                  {{ user.user.name }}
                </td>
                <td>
                  {{ user.created }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- end  table -->

    <!--   Apps  Pagination     -->
    <ul class="pagination pagination-rounded justify-content-center mb-2">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
          p
        }}</a>
      </li>

      <li class="page-item" :class="{ disabled: page == tot_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
    <!--end-->
  </Layout>
</template>
